import { render } from "./BrowserView.vue?vue&type=template&id=e4f0e850&scoped=true"
import script from "./BrowserView.vue?vue&type=script&lang=js"
export * from "./BrowserView.vue?vue&type=script&lang=js"

import "./BrowserView.vue?vue&type=style&index=0&id=e4f0e850&scoped=true&lang=css"

import exportComponent from "/gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4f0e850"]])

export default __exports__